module.exports = __webpack_public_path__ + "img/CRT_P2_Sword-004.79dfba9e.png";